import React, { useState, useEffect, Fragment, useContext } from 'react';
import AuthContext from '../../Context/autenticacion/authContext';
import SchoolSellerInscriptions from './SchoolSellerInscriptions';

const InscriptionsSeller = (props) => {

	const authContext = useContext(AuthContext);
	const { getSchoolID, schoolID } = authContext;

	useEffect(() => {
		getSchoolID();
    }, []);

	return (

		<SchoolSellerInscriptions 
			schoolID={schoolID}
		/>

	);
};

export default InscriptionsSeller;
